//#region src/js/global.js
function getFocusableElements(container) {
	return Array.from(container.querySelectorAll("summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"));
}
document.querySelectorAll("[id^=\"Details-\"] summary").forEach((summary) => {
	summary.setAttribute("role", "button");
	summary.setAttribute("aria-expanded", summary.parentNode.hasAttribute("open"));
	if (summary.nextElementSibling.getAttribute("id")) summary.setAttribute("aria-controls", summary.nextElementSibling.id);
	summary.addEventListener("click", (event) => {
		event.currentTarget.setAttribute("aria-expanded", !event.currentTarget.closest("details").hasAttribute("open"));
	});
	if (summary.closest("header-drawer, menu-drawer")) return;
	summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});
var trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
	const elements = getFocusableElements(container);
	const first = elements[0];
	const last = elements[elements.length - 1];
	removeTrapFocus();
	trapFocusHandlers.focusin = (event) => {
		if (event.target !== container && event.target !== last && event.target !== first) return;
		document.addEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.focusout = function() {
		document.removeEventListener("keydown", trapFocusHandlers.keydown);
	};
	trapFocusHandlers.keydown = function(event) {
		if (event.code.toUpperCase() !== "TAB") return;
		if (event.target === last && !event.shiftKey) {
			event.preventDefault();
			first.focus();
		}
		if ((event.target === container || event.target === first) && event.shiftKey) {
			event.preventDefault();
			last.focus();
		}
	};
	document.addEventListener("focusout", trapFocusHandlers.focusout);
	document.addEventListener("focusin", trapFocusHandlers.focusin);
	elementToFocus.focus();
	if (elementToFocus.tagName === "INPUT" && [
		"search",
		"text",
		"email",
		"url"
	].includes(elementToFocus.type) && elementToFocus.value) elementToFocus.setSelectionRange(0, elementToFocus.value.length);
}
try {
	document.querySelector(":focus-visible");
} catch {
	focusVisiblePolyfill();
}
function focusVisiblePolyfill() {
	const navKeys = [
		"ARROWUP",
		"ARROWDOWN",
		"ARROWLEFT",
		"ARROWRIGHT",
		"TAB",
		"ENTER",
		"SPACE",
		"ESCAPE",
		"HOME",
		"END",
		"PAGEUP",
		"PAGEDOWN"
	];
	let currentFocusedElement = null;
	let mouseClick = null;
	window.addEventListener("keydown", (event) => {
		if (navKeys.includes(event.code.toUpperCase())) mouseClick = false;
	});
	window.addEventListener("mousedown", () => {
		mouseClick = true;
	});
	window.addEventListener("focus", () => {
		if (currentFocusedElement) currentFocusedElement.classList.remove("focused");
		if (mouseClick) return;
		currentFocusedElement = document.activeElement;
		currentFocusedElement.classList.add("focused");
	}, true);
}
function pauseAllMedia() {
	document.querySelectorAll(".js-youtube").forEach((video) => {
		video.contentWindow.postMessage("{\"event\":\"command\",\"func\":\"pauseVideo\",\"args\":\"\"}", "*");
	});
	document.querySelectorAll(".js-vimeo").forEach((video) => {
		video.contentWindow.postMessage("{\"method\":\"pause\"}", "*");
	});
	document.querySelectorAll("video").forEach((video) => video.pause());
	document.querySelectorAll("product-model").forEach((model) => {
		if (model.modelViewerUI) model.modelViewerUI.pause();
	});
}
function removeTrapFocus(elementToFocus = null) {
	document.removeEventListener("focusin", trapFocusHandlers.focusin);
	document.removeEventListener("focusout", trapFocusHandlers.focusout);
	document.removeEventListener("keydown", trapFocusHandlers.keydown);
	if (elementToFocus) elementToFocus.focus();
}
function onKeyUpEscape(event) {
	if (event.code.toUpperCase() !== "ESCAPE") return;
	const openDetailsElement = event.target.closest("details[open]");
	if (!openDetailsElement) return;
	const summaryElement = openDetailsElement.querySelector("summary");
	openDetailsElement.removeAttribute("open");
	summaryElement.setAttribute("aria-expanded", false);
	summaryElement.focus();
}
function debounce(fn, wait) {
	let t;
	return (...args) => {
		clearTimeout(t);
		t = setTimeout(() => fn.apply(this, args), wait);
	};
}
function throttle(fn, delay) {
	let lastCall = 0;
	return function(...args) {
		const now = (/* @__PURE__ */ new Date()).getTime();
		if (now - lastCall < delay) return;
		lastCall = now;
		return fn(...args);
	};
}
function fetchConfig(type = "json") {
	return {
		method: "POST",
		headers: {
			"Content-Type": "application/json",
			Accept: `application/${type}`
		}
	};
}
window.trapFocus = trapFocus;
window.pauseAllMedia = pauseAllMedia;
window.debounce = debounce;
window.throttle = throttle;
window.fetchConfig = fetchConfig;
if (typeof window.Shopify === "undefined") window.Shopify = {};
Shopify.bind = function(fn, scope) {
	return function() {
		return fn.apply(scope, arguments);
	};
};
Shopify.setSelectorByValue = function(selector, value) {
	for (let i = 0, count = selector.options.length; i < count; i++) {
		const option = selector.options[i];
		if (value === option.value || value === option.innerHTML) {
			selector.selectedIndex = i;
			return i;
		}
	}
};
Shopify.addListener = function(target, eventName, callback) {
	target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent(`on${eventName}`, callback);
};
Shopify.postLink = function(path, options) {
	options = options || {};
	const method = options.method || "post";
	const params = options.parameters || {};
	const form = document.createElement("form");
	form.setAttribute("method", method);
	form.setAttribute("action", path);
	for (const key in params) {
		const hiddenField = document.createElement("input");
		hiddenField.setAttribute("type", "hidden");
		hiddenField.setAttribute("name", key);
		hiddenField.setAttribute("value", params[key]);
		form.appendChild(hiddenField);
	}
	document.body.appendChild(form);
	form.submit();
	document.body.removeChild(form);
};
Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
	this.countryEl = document.getElementById(country_domid);
	this.provinceEl = document.getElementById(province_domid);
	this.provinceContainer = document.getElementById(options.hideElement || province_domid);
	Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this));
	this.initCountry();
	this.initProvince();
};
Shopify.CountryProvinceSelector.prototype = {
	initCountry() {
		const value = this.countryEl.getAttribute("data-default");
		Shopify.setSelectorByValue(this.countryEl, value);
		this.countryHandler();
	},
	initProvince() {
		const value = this.provinceEl.getAttribute("data-default");
		if (value && this.provinceEl.options.length > 0) Shopify.setSelectorByValue(this.provinceEl, value);
	},
	countryHandler() {
		const raw = this.countryEl.options[this.countryEl.selectedIndex].getAttribute("data-provinces");
		const provinces = JSON.parse(raw);
		this.clearOptions(this.provinceEl);
		if (provinces && provinces.length === 0) this.provinceContainer.style.display = "none";
		else {
			for (let i = 0; i < provinces.length; i++) {
				const provinceOption = document.createElement("option");
				provinceOption.value = provinces[i][0];
				provinceOption.innerHTML = provinces[i][1];
				this.provinceEl.appendChild(provinceOption);
			}
			this.provinceContainer.style.display = "";
		}
	},
	clearOptions(selector) {
		while (selector.firstChild) selector.removeChild(selector.firstChild);
	},
	setOptions(selector, values) {
		for (let i = 0; i < values.length; i++) {
			const opt = document.createElement("option");
			opt.value = values[i];
			opt.innerHTML = values[i];
			selector.appendChild(opt);
		}
	}
};
/**
* Email validate function
*
*/
var emailLabel = document.querySelector("[data-field-email-label]");
var emailField = document.querySelector("[data-field-email]");
function removeInvalidClasses() {
	emailField.classList.remove("invalid:border-red-400");
	emailLabel.classList.remove("top-[10px]");
}
function validateEmail() {
	if (emailField.value === "" || /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(emailField.value)) removeInvalidClasses();
	else {
		emailField.classList.add("invalid:border-red-400");
		emailLabel.classList.add("top-[10px]");
	}
}
if (document.querySelector("[data-field-email]")) document.querySelector("[data-field-email]").addEventListener("change", validateEmail);
/**
*
* Function sticky header + main content padding
*
* @since 1.0
*/
(function() {
	const header = document.querySelector(".header-section div");
	const announcementBar = document.querySelector(".announcement-bar div");
	if (!header) return;
	const indexTemplate = document.querySelector("[data-template-index]");
	const mainContent = document.querySelector(".MainContent");
	const menuDrawer = document.querySelector("menu-drawer");
	function setToTop() {
		if (mainContent) {
			const headerHeight = header.offsetHeight;
			mainContent.style.paddingTop = `${headerHeight}px`;
		}
	}
	function pushHeader() {
		if (header && announcementBar) {
			const announcementBarHeight = announcementBar.offsetHeight;
			header.style.marginTop = `${announcementBarHeight}px`;
		}
	}
	function setPaddingTopToMainContent() {
		if (mainContent) {
			const headerHeight = header.offsetHeight;
			const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
			if (window.innerWidth < 1024) {
				const totalHeight = headerHeight + announcementBarHeight;
				mainContent.style.paddingTop = `${totalHeight}px`;
			} else {
				const totalHeight = headerHeight + announcementBarHeight + 20;
				mainContent.style.paddingTop = `${totalHeight}px`;
			}
		}
	}
	function setPaddingTopToMenuDrawer() {
		if (menuDrawer) {
			const headerHeight = header.offsetHeight;
			const announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;
			if (!indexTemplate) {
				const totalHeight = headerHeight + announcementBarHeight;
				menuDrawer.style.top = `${totalHeight}px`;
			} else if (announcementBar) {
				const totalHeight = headerHeight + announcementBarHeight;
				menuDrawer.style.top = `${totalHeight}px`;
			} else menuDrawer.style.top = `${headerHeight}px`;
		}
	}
	function handleScroll() {
		const shouldAddWhite = (window.scrollY || document.documentElement.scrollTop) > 50;
		header.classList.toggle("bg-white", shouldAddWhite);
		header.classList.toggle("text-black", shouldAddWhite);
		header.classList.toggle("svg-color", shouldAddWhite);
		header.classList.toggle("bg-black/20", !shouldAddWhite);
		header.classList.toggle("text-white", !shouldAddWhite);
		header.classList.toggle("svg-color", !shouldAddWhite);
	}
	if (!indexTemplate) {
		header.classList.add("bg-white");
		setToTop();
		setPaddingTopToMainContent();
		setPaddingTopToMenuDrawer();
		pushHeader();
	} else {
		window.addEventListener("scroll", handleScroll);
		setPaddingTopToMenuDrawer();
		pushHeader();
	}
	function updateHeaderBackground() {
		if (menuDrawer.classList.contains("open")) header.classList.add("menu-open-header");
		else header.classList.remove("menu-open-header");
	}
	new MutationObserver((mutations) => {
		mutations.forEach((mutation) => {
			if (mutation.type === "attributes" && mutation.attributeName === "class") updateHeaderBackground();
		});
	}).observe(menuDrawer, { attributes: true });
	updateHeaderBackground();
})();
/**
*
* Shopify Chat functionality - Hide form initially, show after FAQ click
*
* @since 1.0
*/
(function() {
	function initShopifyChat() {
		const shopifyChatContainer = document.querySelector("#ShopifyChat");
		if (!shopifyChatContainer) {
			setTimeout(initShopifyChat, 1e3);
			return;
		}
		const shadowRoot = shopifyChatContainer.shadowRoot;
		if (!shadowRoot) {
			setTimeout(initShopifyChat, 1e3);
			return;
		}
		function hideChatForm() {
			const chatForm = shadowRoot.querySelector("form.composer-bar-form.form-multiple-lines");
			if (chatForm) chatForm.style.display = "none";
		}
		function showChatForm() {
			const chatForm = shadowRoot.querySelector("form.composer-bar-form.form-multiple-lines");
			if (chatForm) chatForm.style.display = "block";
		}
		function handleFAQClick(event) {
			if (event.target.matches("button.outline-button.instant-answers-list__prompt")) showChatForm();
		}
		hideChatForm();
		shadowRoot.addEventListener("click", handleFAQClick);
		new MutationObserver((mutations) => {
			mutations.forEach((mutation) => {
				if (mutation.type === "childList") {
					if (shadowRoot.querySelectorAll("button.outline-button.instant-answers-list__prompt").length > 0) hideChatForm();
				}
			});
		}).observe(shadowRoot, {
			childList: true,
			subtree: true
		});
		const formCheckInterval = setInterval(() => {
			const chatForm = shadowRoot.querySelector("form.composer-bar-form.form-multiple-lines");
			if (chatForm && chatForm.style.display !== "none") hideChatForm();
		}, 2e3);
		setTimeout(() => {
			clearInterval(formCheckInterval);
		}, 3e4);
	}
	if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", initShopifyChat);
	else initShopifyChat();
	window.addEventListener("load", initShopifyChat);
})();
//#endregion
